module.exports = __webpack_public_path__ + "img/zhfw.eb71feaf.png";